import { essentialCookies } from './data';

export function allDomainCandidates(hostname = location.hostname) {
  // 예: a.b.flipster.io → ["a.b.flipster.io","b.flipster.io","flipster.io"]
  const parts = hostname.split('.');
  const res = [];
  for (let i = 0; i < parts.length - 1; i++) {
    res.push(parts.slice(i).join('.'));
  }
  return res;
}

export function deleteCookieEverywhere(name: string) {
  const domains = allDomainCandidates();
  // TODO: en won't work but no usecase
  const paths = ['/', location.pathname.split('/').slice(0, 2).join('/') || '/'];
  const expires = 'Thu, 01 Jan 1970 00:00:00 GMT';

  // 기본 도메인/루트
  document.cookie = `${name}=; Expires=${expires}; Path=/`;

  // 가능한 domain/path 조합 시도
  domains.forEach((d) => {
    paths.forEach((p) => {
      document.cookie = `${name}=; Expires=${expires}; Path=${p}; Domain=.${d}`;
      document.cookie = `${name}=; Expires=${expires}; Path=${p}; Domain=.${d}; Secure; SameSite=None`;
    });
  });
}

export function purgeNonEssentialCookies() {
  const pairs = document.cookie.split(';').map((v) => v.trim());
  for (const pair of pairs) {
    const [rawName] = pair.split('=');
    const name = decodeURIComponent(rawName || '').trim();
    if (name && !essentialCookies.includes(name)) {
      deleteCookieEverywhere(name);
    }
  }
}

type CountryInfo = {
  country?: string | null;
};

export async function getCountryFromVercel() {
  const response = await fetch('/api/country');
  const data = (await response.json()) as CountryInfo;
  return data.country ?? null;
}
